<template>
  <div>
    <h2 class="mt-4 mb-0 text-black-50 parcel-direction">
      {{ type }}
      <span class="text-body">{{ shipment.shipmentNumber }}</span>
      {{ t('from') }}
      <span class="text-body">{{ from }}</span>
    </h2>
    <div v-if="originalShipmentNumber" class="text-black-50">
      {{ t('previousShipmentNumber') }} <b>{{ originalShipmentNumber }}</b>
    </div>
    <hr class="tracking-divider" />
  </div>
</template>

<script lang="ts">
import type { Shipment, TrackingData } from '@/types/Models/Shipment'
import { defineComponent, computed, type PropType, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { DistributionChannels } from '@/consts/DistributionChannels'

export default defineComponent({
  name: 'ShipmentTitle',
  props: {
    itemData: {
      type: Object as PropType<TrackingData>,
      required: true,
    },
    shipment: {
      type: Object as PropType<Shipment>,
      required: true,
    },
    originalShipment: {
      type: Object as PropType<Shipment | null>,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const type: ComputedRef<string> = computed(() => {
      return DistributionChannels.getName(props.itemData.distributionChannel)
    })

    const from: ComputedRef<string> = computed(() => {
      return props.itemData?.sender?.company || props.itemData?.sender?.name || ''
    })

    const originalShipmentNumber: ComputedRef<string> = computed(() => props.originalShipment?.shipmentNumber || '')

    return {
      type,
      from,
      originalShipmentNumber,
      t,
    }
  },
})
</script>
